
/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import { actionCreatorFactory } from 'typescript-fsa';
import { UserGroup } from '../../services/betting';

const actionCreator = actionCreatorFactory();

export const setUserGroupSearchString = actionCreator<string>('SET_USER_GROUP_SEARCH_STRING');

export const setUserGroups = actionCreator<UserGroup[]>('SET_USER_GROUPS');

export const setUserGroupCount = actionCreator<number>('SET_USER_GROUP_COUNT');

export const setUserGroupStartPos = actionCreator<number>('SET_USER_GROUP_START_POS');

export const setUserGroupsPriorEnabled = actionCreator<Boolean>('SET_USER_GROUP_PRIOR_ENABLED');

export const setUserGroupsNextEnabled = actionCreator<Boolean>('SET_USER_GROUP_NEXT_ENABLED');

export const SEARCH_USER_GROUPS = 'SEARCH_USER_GROUPS';
export const searchUserGroups = actionCreator<String>(SEARCH_USER_GROUPS);

export const FETCH_USER_GROUPS = 'FETCH_USER_GROUPS';
export const fetchUserGroups = actionCreator(FETCH_USER_GROUPS);

export const COUNT_USER_GROUPS = 'COUNT_USER_GROUPS';
export const countUserGroups = actionCreator(COUNT_USER_GROUPS);

export const PAGE_UP_USER_GROUPS = 'PAGE_UP_USER_GROUPS';
export const pageUpUserGroups = actionCreator(PAGE_UP_USER_GROUPS);

export const PAGE_DOWN_USER_GROUPS = 'PAGE_DOWN_USER_GROUPS';
export const pageDownUserGroups = actionCreator(PAGE_DOWN_USER_GROUPS);

export const PAGE_LAST_USER_GROUPS = 'PAGE_LAST_USER_GROUPS';
export const pageLastUserGroups = actionCreator(PAGE_LAST_USER_GROUPS);

export const PAGE_FIRST_USER_GROUPS = 'PAGE_FIRST_USER_GROUPS';
export const pageFirstUserGroups = actionCreator(PAGE_FIRST_USER_GROUPS);

export const USER_GROUPS_IS_LOADING = 'USER_GROUPS_IS_LOADING';
export const userGroupsIsLoading = actionCreator<boolean>(USER_GROUPS_IS_LOADING);
